import React from 'react';
import { alpha, Stack } from '@mui/material';
import { useAsset } from '@ocx/data-configuration';
import { Paper, Typography } from '@ocx/ui';

import { SizingMultiplier } from '../../theme/constants';

export interface ISelectedStoreCardProps {
  addressLine1: string;
  addressLine2: string;
}

export const SelectedStoreCard: React.FC<ISelectedStoreCardProps> = (props) => {
  const { addressLine1, addressLine2 } = props;
  const mapMarkerSrc = useAsset('MapMarker');

  return (
    <Paper
      p={0}
      sx={{
        backgroundColor: (theme) => alpha(theme.palette.background.paper, 0.9),
      }}>
      <Stack
        minHeight={140}
        p={SizingMultiplier.md}
        spacing={SizingMultiplier.sm}
        alignItems="center"
        justifyContent="center">
        <img width={40} src={mapMarkerSrc} alt="marker" />

        <Typography variant="h5">{addressLine1}</Typography>
        <Typography variant="body2" color="text.disabled">
          {addressLine2}
        </Typography>
      </Stack>
    </Paper>
  );
};
